<template lang="pug">
.textfield
  label {{ label }}
    span(v-if='required && label') *

  v-text-field(
    :error-messages='errorMessages',
    v-bind='$attrs',
    v-on='$listeners',
    @change='onChange',
    @blur='onBlur',
    solo,
    v-model.trim='model'
    )
</template>

<script>
export default {
  props: {
    value: null,
    'error-messages': null,
    label: String,
    required: Boolean
  },

  data () {
    return {
      model: this.value
    }
  },

  methods: {
    onBlur () {
      if (this.$listeners.blur) this.$listeners.blur()
    },

    onChange () {
      if (this.$listeners.change) this.$listeners.change()
    }
  },

  watch: {
    model (v) {
      this.$emit('input', v)
    },

    value (v) {
      this.model = v
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
